<div class="canvas-container" [ngStyle]="{ 'visibility': (zoomToFitInProgress ? 'hidden' : 'visible') }" [ngClass]="{
		'canvas--grabbable': !dragDisabled && !isGrabbingCanvas && !contentFits,
		'canvas--grabbing': isGrabbingCanvas && !contentFits,
		'is-vertical' : isVertical
	}">

	<div class="canvas" [ngStyle]="{ 
			'transform': this.getCanvasScale(),
			'transform-origin': getCanvasTransformOrigin(),
			'top': canvasPosition.y + 'px',
			'left': canvasPosition.x + 'px'
		}">
		<ng-content></ng-content>
	</div>

	<div class="outline" *ngIf="outline" #outlineEl (mouseup)="outlineClicked($event)"
		[ngStyle]="{ 'width' : outlineWidth, 'height' : outlineHeight }">

		<div class="window" #outlineWindowEl [ngStyle]="{ 
			'width': outlineWindowWidth,
			'height': outlineWindowHeight,
			'left': outlineWindowLeft,
			'top': outlineWindowTop
		}"></div>
	</div>

	<div class="controls" #controlsEl>
		<div class="controls__zoom">
			<button class="button join-right" (click)="zoomOut()" [ngClass]=" { 'disabled': zoom === 0 }"><i
					class="fa fa-minus"></i>
			</button>
			<button class="button join-left join-right zoom-level-text">
				{{ ( zoom + 1 ) * (100 / zoomLevels.length) }}%
			</button>
			<button class="button join-left" (click)="zoomIn()"
				[ngClass]=" { 'disabled': zoom === (zoomLevels.length - 1) }">
				<i class="fa fa-plus"></i>
			</button>
		</div>
	</div>

</div>
